import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

import "./EventDetailSummary.scss";
import { EventUserCount } from '../../parts/EventUserCount/EventUserCount';

export const EventDetailSummary = (props)=>{
    const { event, detail } = props;
    const { labels } = detail;
    const SignIcon = detail.isSigned ? CheckCircleOutlineOutlinedIcon : PersonOutlineOutlinedIcon;

    return (
        <section className="EventDetailSummary">
            <Block tagName="section" className="summaryPanel wall -form">
                <div className="header"><Caption>{labels.participation}</Caption></div>
                <div className="body">
                    <SignIcon className="panelIcon"/>
                    <div>
                        <strong>{detail.signTitle}</strong>
                        <p className={detail.isSigned ? "positive" : ""}>{detail.signLabel}</p>
                        {detail.inviteLabel && <p>{detail.inviteLabel}</p>}
                    </div>
                </div>
            </Block>
            <Block tagName="section" className="summaryPanel wall -form">
                <div className="header"><Caption>{labels.crew}</Caption></div>
                <div className="body">
                    <GroupsOutlinedIcon className="panelIcon"/>
                    <div>
                        <EventUserCount value={detail.signedCount} row={event}/>
                        <p>{detail.sureCount}/{detail.maxUsers} {labels.confirmed}</p>
                        <p>{labels.minUsers}: {detail.minUsers}</p>
                        <p>{labels.unsureCount}: {detail.unsureCount}</p>
                    </div>
                </div>
            </Block>
        </section>
    )
}
